import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import React from 'react'
import { Button, Typography } from '@s4l/ds'
import { useS4LContext } from '@s4l/react-context'
import { IconCallCenter } from '@s4l/icons/IconCallCenter'
import { IconEmail } from '@s4l/icons/IconEmail'
import { SupportInfo as SupportInfoItems } from '@s4l/stayforlong/booking/SupportInfo'
import styles from './index.module.css'

interface SupportInfoProps {
  supportInfoJSON?: ReturnType<SupportInfoItems['toJSON']>
}

function SupportInfo({ supportInfoJSON }: Readonly<SupportInfoProps>) {
  const { i18n } = useS4LContext()
  const supportInfoInformation = SupportInfoItems.fromJSONOrUndefined(supportInfoJSON)

  if (!supportInfoInformation) return null

  return (
    <section className={styles.supportInfo}>
      <Typography variant="title" size="xs" as="h3">
        {i18n.formatMessage({ id: 'global.help-booking' })}
      </Typography>
      <Typography variant="body" size="l" as="p">
        {i18n.formatMessage({ id: 'global.contact-us' })}
      </Typography>
      <div className={styles.buttonsContainer}>
        {supportInfoInformation.phone && (
          <Button
            as="a"
            variant="outlined-rounded"
            leadingIcon={<IconCallCenter />}
            size="small"
            href={`tel:${supportInfoInformation.phone}`}
            data-testid="phone-button"
          >
            {supportInfoInformation.phone}
          </Button>
        )}
        <Button
          as="a"
          variant="outlined-rounded"
          leadingIcon={<IconEmail />}
          size="small"
          href={`mailto:${supportInfoInformation.email}`}
          data-testid="email-button"
        >
          {supportInfoInformation.email}
        </Button>
      </div>
    </section>
  )
}

SupportInfo.displayName = 'SupportInfo'
export default withErrorBoundary(SupportInfo)
